import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface FileFolderMenuItem {
  label: string;
  action: string;
  icon?: string;
}

export interface FileFolder {
  name: string;
  type: string;
  id: any;
  children?: FileFolder[];
  parentId?: string;
  metadata?: any;
  expanded?: boolean;
  avoidDelete?: boolean;
  avoidEdit?: boolean;
  avoidDrag?: boolean;
  menuItems: FileFolderMenuItem[];
}

@Component({
  selector: "app-file-explorer",
  templateUrl: "./file-explorer.component.html",
  styleUrls: ["./file-explorer.component.scss"],
})
export class FileExplorerComponent {
  public hoveredItem;
  @Input() deleteableItems;
  @Input() showEditIcon;
  @Input() draggableItems;
  @Input() selected = "";
  @Input() root = true;
  @Input() items: FileFolder[] = [];
  @Output() itemClicked = new EventEmitter<FileFolder>();
  @Output() itemDelete = new EventEmitter<FileFolder>();
  @Output() editClicked = new EventEmitter<FileFolder>();
  @Output() itemDropped = new EventEmitter<{
    item: FileFolder;
    target: FileFolder | null;
  }>();
  public draggingItem: FileFolder | null = null;

  onItemClick(item: FileFolder): void {
    this.itemClicked.emit(item);
  }

  onItemDragged(item: FileFolder, event: DragEvent): void {
    event.stopPropagation();
    this.draggingItem = item;
    event.dataTransfer?.setData("text", JSON.stringify(item));
  }

  onItemDrop(targetItem: FileFolder, event: DragEvent): void {
    event.preventDefault();
    this.draggingItem = null;
    const data = event.dataTransfer?.getData("text");
    const draggedItem = data ? JSON.parse(data) : null;
    if (draggedItem) {
      this.itemDropped.emit({ item: draggedItem, target: targetItem });
    }
    event.stopPropagation();
  }

  onRootDrop(event: DragEvent): void {
    if (!this.draggableItems) return;

    event.preventDefault();
    const data = event.dataTransfer?.getData("text");
    const draggedItem = data ? JSON.parse(data) : null;
    if (draggedItem?.type === "folder") {
      this.itemDropped.emit({ item: draggedItem, target: null });
    }
    event.stopPropagation();
  }

  onRootDragOver(event: DragEvent): void {
    if (this.draggableItems) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }
  handleItemDrop(event) {
    this.itemDropped.emit(event);
  }

  handleEdit(item, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.editClicked.emit(item);
  }

  handleDelete(item, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.itemDelete.emit(item);
  }
}
